// Tarjetas Visa

const portones = {
  regional: [
    {
      title: 'Un dólar, un Benefit',
      icon: 'tickets',
      content: [
        'Cada vez que usás tu tarjeta Itaú Benefits dentro y fuera de Portones Shopping acumulás Benefits que podés canjear por vales obsequio para usar en todos los locales, excepto Abitab, Cambio Indumex, Redpagos, Movie, Metraje de OCA y Devoto.',
        'Por cada dólar de consumo, o su equivalente de pesos, acumulás un Benefit, con excepción de los cargos bancarios.',
        'El consumo de combustible y los débitos automáticos también generan Benefits.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además generan Benefits a la cuenta Benefits del titular. La tarjeta Visa Benefits Regional del titular y sus adicionales no tienen costo de emisión por un año.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Regional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El límite de crédito será definido según nuestras políticas y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de 500 Benefits',
      icon: 'star',
      content: ['Con tu primera compra obtenés un Bono de Bienvenida de 500 Benefits.'],
    },
    {
      title: 'Benefit por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con esta tarjeta generarán Benefits, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos bancarios (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Benefits.',
      ],
    },
  ],
  internacional: [
    {
      title: 'Un dólar, un Benefit',
      icon: 'tickets',
      content: [
        'Cada vez que usás tu tarjeta Itaú Benefits dentro y fuera de Portones Shopping acumulás Benefits que podés canjear por vales obsequio para usar en todos los locales, excepto Abitab, Cambio Indumex, Redpagos, Movie, Metraje de OCA y Devoto.',
        'Por cada dólar de consumo, o su equivalente de pesos, acumulás un Benefit, con excepción de los cargos bancarios.',
        'El consumo de combustible y los débitos automáticos también generan Benefits. ',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además generan Benefits a la cuenta Benefits del titular. La tarjeta Visa Benefits Regional del titular y sus adicionales no tienen costo de emisión por un año. ',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Internacional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El límite de crédito será definido según nuestras políticas y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de 500 Benefits',
      icon: 'star',
      content: ['Con tu primera compra obtenés un Bono de Bienvenida de 500 Benefits.'],
    },
    {
      title: 'Benefit por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con esta tarjeta generarán Benefits, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos bancarios (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Benefits.',
      ],
    },
  ],
  oro: [
    {
      title: 'Un dólar, un Benefit',
      icon: 'tickets',
      content: [
        'Cada vez que usás tu tarjeta Itaú Benefits dentro y fuera de Portones Shopping acumulás Benefits que podés canjear por vales obsequio para usar en todos los locales, excepto Abitab, Cambio Indumex, Redpagos, Movie, Metraje de OCA y Devoto.',
        'Por cada dólar de consumo, o su equivalente de pesos, acumulás un Benefit, con excepción de los cargos bancarios.',
        'El consumo de combustible y los débitos automáticos también generan Benefits. ',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además generan Benefits a la cuenta Benefits del titular. La tarjeta Visa Benefits Regional del titular y sus adicionales no tienen costo de emisión por un año.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Benefits Oro tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El mínimo es de $60.000. Este crédito puede aumentar automáticamente según lo que nos devuelva el sistema. Si tu ingreso es mayor a $60.000 tu crédito será mayor.',
      ],
    },
    {
      title: 'Bono de 500 Benefits',
      icon: 'star',
      content: ['Con tu primera compra obtenés un Bono de Bienvenida de 500 Benefits.'],
    },
    {
      title: 'Benefit por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con esta tarjeta generarán Benefits, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos bancarios (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Benefits.',
      ],
    },
  ],
  platinum: [
    {
      title: 'Un dólar, un Benefit',
      icon: 'tickets',
      content: [
        'Cada vez que usás tu tarjeta Itaú Benefits dentro y fuera de Portones Shopping acumulás Benefits que podés canjear por vales obsequio para usar en todos los locales, excepto Abitab, Cambio Indumex, Redpagos, Movie, Metraje de OCA y Devoto.',
        'Por cada dólar de consumo, o su equivalente de pesos, acumulás un Benefit, con excepción de los cargos bancarios.',
        'El consumo de combustible y los débitos automáticos también generan Benefits. ',
      ],
    },
    {
      title: 'Priority Pass',
      icon: 'vip',
      content: [
        'Los titulares de la tarjeta Visa Platinum e Infinite de Itaú reciben junto con ésta la tarjeta Priority Pass. La misma permite ser parte del programa independiente de acceso a salas VIP de aeropuertos más amplio del mundo.',
        'La tarjeta Priority Pass te brinda 7 accesos gratis al año (calendario). A partir del octavo acceso, se cargará a la tarjeta de crédito del titular cada acceso adicional a USD 27.',
        'Para ver la lista de Salas Vip adheridas y bases y condiciones hacé <a href="https://www.prioritypass.com/en/airport-lounges">click aquí</a>.',
      ],
    },
    {
      title: 'Servicio de asistencia médica en Viaje: Cobertura brindada por Universal Assistance',
      icon: 'lock',
      content: [
        '<strong>Área de Cobertura:</strong> Todo el mundo (excepto la República Oriental del Uruguay).',
        '<strong>Beneficiarios:</strong> Tarjeta habientes, cónyuges e hijos dependientes menores de 21 años.',
        '<strong>Prestaciones:</strong> Asistencia Médica, Odontológica, Jurídica y Localización de Equipaje.',
        'Los beneficiarios cuentan con el Servicio de Asistencia en Viajes que brinda Universal Assistance de hasta USD 15.000 por persona.',
        'Para solicitar la asistencia a través de Universal Assistance siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido.',
        '<a href="https://www.itau.com.uy/inst/aci/docs/condiciones_generales.pdf">Ver condiciones</a>',
      ],
    },
    {
      title: 'Cobertura brindada por AXA USA',
      // icon: 'money-circle',
      content: [
        'Además, si se abona el pasaje de avión con Itaú Visa Platinum, cuentan con la siguiente cobertura a través de AXA USA (*).',
        'Asistencia en Viajes de hasta un máximo de USD 50.000 en todo el mundo.',
        '<strong>Beneficiarios:</strong> titular, cónyuge e hijos menores de 23 años.',
        '<strong>(*)</strong> Los seguros de Asistencia en Viajes no son acumulables.',
        '<strong>(**)</strong> Países firmantes del tratado Schengen.',
        'Para solicitar la asistencia a través de AXA siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. Hacé <a href="https://www.itau.com.uy/inst/aci/docs/Seguros%20AXA.pdf">click aquí</a> para ver los números de teléfono.',
        '<a href="https://www.itau.com.uy/inst/aci/docs/servicios_de_emergencia_medica_internacional_AXA_platinum.pdf">Ver condiciones</a>',
        'Si querés solicitar el certificado Schengen para viajes a Europa, regístrate en el portal de Visa haciendo <a href="https://visabenefitslac.axa-assistance.us/">click aquí</a>.',
      ],
    },
    {
      title: 'Seguros',
      // icon: 'star',
      content: [
        'Por más información sobre seguros <a href="https://www.visa.com.uy/pague-con-visa/tarjetas/credito/visa-platinum.html">clic aquí</a>.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además generan Benefits a la cuenta Benefits del titular. La tarjeta Visa Benefits Platinum del titular y sus adicionales no tienen costo de emisión por un año.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Benefits Platinum tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <strong>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo</strong>. Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El mínimo es de $120.000. Este crédito puede aumentar automáticamente según lo que nos devuelva el sistema. Si tu ingreso es mayor a $120.000 tu crédito será mayor.',
      ],
    },
    {
      title: 'Bono de 500 Benefits',
      icon: 'star',
      content: ['Con tu primera compra obtenés un Bono de Bienvenida de 500 Benefits.'],
    },
    {
      title: 'Benefit por consumo',
      icon: 'cart',
      content: [
        'Todos los consumos que realizás con esta tarjeta generarán Benefits, a excepción de los retiros de dinero en efectivo y los cargos por intereses o cargos bancarios (comisiones).',
        'El consumo de combustible y los débitos automáticos también generan Benefits.',
      ],
    },
  ],
};

export default portones;
